/* Handles prices on order summary section on cart, checkout and orderConfrimation */
import mobileMixin from '../../common/mixins/mobile-mixin';
import globals from '../../common/globals';
import { checkoutEventBus } from '../../../modules/event-bus';
import vxModal from '../../common/vx-modal/vx-modal.vue';
import { pageType } from '../../common/mixins/vx-enums';

export default {
  name: 'vx-order-summary-details',
  components: {
    vxModal,
  },
  props: {
    // Text coming from property file
    i18n: Object,
    // Indicates if page is cart/checkout/orderConfirmation/orderApprovalDetails/orderDetails
    page: String,
    // Order summary details
    orderSummaryData: Object,
    // Indicates if there are any gift products in cart
    giftable: Boolean,
    // Indicates if there are any installation products in cart
    installable: Boolean,
    // Indicates if Multiple/Single Shipping is opted
    isShippingMultiple: Boolean,
  },
  data() {
    return {
      globals,
      orderSummaryClicked: false,
      isGiftable: false,
      isInstallable: false,
      pageType,
    };
  },
  mixins: [mobileMixin],
  computed: {},
  mounted() {
    this.isGiftable = this.giftable;
    this.isInstallable = this.installable;
  },
  methods: {
    /**
     * This function opens the entire order summary section in mobile view on cart page
     */
    openOrderSummary(event) {
      this.orderSummaryClicked = !this.orderSummaryClicked;
      this.$root.$emit('orderSummaryScrollUp', this.orderSummaryClicked);
    },
    /**
     * This function opens a madal that shows details about installation service
     */
    openInstallationModal() {
      this.$refs.installableMoreInfo.open();
    },
    /**
     * This function shows progress bar based on the free shipping promotions on cart page
     * @param  {Object} orderSummaryData orderSummary Data
     */
    getProgressbarStyle(orderSummaryData) {
      const freeShippingLimitBalance = parseInt(orderSummaryData.freeShippingLimit, 10) || 0;
      const subtotal = parseInt(orderSummaryData.subTotal.value, 10);
      const progressPercentage = (subtotal * 100) / (subtotal + freeShippingLimitBalance);
      const obj = {
        width: `${progressPercentage}%`,
      };
      return obj;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/common/vx-order-summary-details/vx-order-summary-details.js